import React from "react";
import { Box, Flex, Text, Stack,  Icon, Image } from "@chakra-ui/react";
import { FaInstagram, FaLinkedin } from "react-icons/fa";

// Example decorative flower icon
import FlowerIcon from "../../assets/home/flower.png";
import FlowerImage from "component/FlowerImage";
import cream from "../../assets/flower/cream.png";
import grey from "../../assets/flower/greyish.png";
import { FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Box bg="#005770" color="white" pt={12} position="relative">
      <FlowerImage
        src={cream}
        top={{ base: "7%", md: "60%" }}
        left={{ base: "34%", md: "5%" }}
      />
      <FlowerImage
        src={grey}
        top={{ base: "74%", md: "10%" }}
        right={{ base: "14%", md: "5%" }}
      />

      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="flex-start"
        px={{ base: 6, md: 20 }}
        gap={{ base: 10, md: 0 }}
      >
        {/* Left - Branding */}
        <Box maxW="250px" position="relative">
          <Box bg="gray.300" h="50px" w="80px" mb={4} borderRadius="md" />
          <Text fontWeight="bold" fontSize="lg" mb={2}  >
            You think we execute
          </Text>
          <Text fontSize="sm"  >
            Your go-to agency for branding, marketing, and web solutions.
          </Text>
          <Image
            src={FlowerIcon}
            alt="Flower"
            boxSize="30px"
            position="absolute"
            bottom={-6}
            left={-6}
            display={{ base: "none", md: "block" }}

          />
        </Box>

        {/* Center - Links */}
        <Stack spacing={2} fontSize="sm">
          <Text fontWeight="bold" mb={2} >
            Top Links
          </Text>
          <Link to="/about-us">• About us</Link>
          <Link to="/our-work">• Our work</Link>
          <Link to="/our-service">• Our services</Link>
          <Link to="/blog">• Blogs</Link>
          <Link to="/contact-us">• Contact us</Link>
          <Link to="/privacy-policy">• Privacy policy</Link>
          <Link to="#">• Terms & conditions</Link>
        </Stack>

        {/* Right - Contact */}
        <Box maxW="250px" position="relative">
          <Text fontWeight="bold" mb={2} >
            Contact
          </Text>
          <Stack spacing={2} fontSize="sm">
            <Text  >• contact@doggleindia.com</Text>
            <Link href="tel:+918509334119" color="blue.200">
              • +91 850-933-4119
            </Link>
            <Link
              href="https://maps.app.goo.gl/XKFXA3RBNLVh"
              isExternal
              color="blue.200"
               
            >
              • Bhamashah Techno Hub, Jaipur, Rajasthan (IN) 302017
            </Link>
          </Stack>

          {/* Social Icons */}
          <Box mt={4}>
            <Text mb={1}  >
              Follow us on
            </Text>
            <Flex gap={2}>
              <Link
                href="https://www.facebook.com/share/1H1tpKBuAe/"
                isExternal
              >
                <Icon as={FaFacebook} boxSize={6} />
              </Link>
              <Link
                href="https://www.instagram.com/doggleindia?igsh=MTQ2a205cnRienhlbQ=="
                isExternal
              >
                <Icon as={FaInstagram} boxSize={6} />
              </Link>
              <Link
                href="https://www.linkedin.com/company/doggleindia/"
                isExternal
              >
                <Icon as={FaLinkedin} boxSize={6} />
              </Link>
            </Flex>
          </Box>

          <Image
            src={FlowerIcon}
            alt="Flower"
            boxSize="30px"
            position="absolute"
            top={0}
            right={-4}
            display={{ base: "none", md: "block" }}
          />
        </Box>
      </Flex>

      {/* Bottom Strip */}
      <Box bg="#C4A77D" mt={10} py={2} textAlign="center">
        <Text fontSize="sm" color="#005770"  >
          ©2025 DoggleIndia. All rights reserved
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
